import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 31 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M29.613 9.031a3.625 3.625 0 0 0-2.55-2.567c-2.25-.607-11.273-.607-11.273-.607s-9.021 0-11.271.607a3.625 3.625 0 0 0-2.551 2.567c-.603 2.265-.603 6.99-.603 6.99s0 4.724.603 6.989c.332 1.25 1.31 2.192 2.55 2.526 2.25.607 11.272.607 11.272.607s9.022 0 11.272-.607c1.241-.334 2.22-1.277 2.551-2.526.603-2.265.603-6.99.603-6.99s0-4.724-.603-6.989ZM12.84 20.311v-8.58l7.54 4.29-7.54 4.29Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "youtube"}) } }